export default {
  id: 88,
  title: 'Target #88 - Tight Corner',
  url: 'https://cssbattle.dev/play/88',
  colors: ['#F7F3DA', '#D25B70'],
  solution:
    '<a a><a b><style>[a],[b]{width:200;height:150}[b],body{background:#f7f3da}a{position:fixed;left:0}[a]{bottom:40;border-radius:0 10px;background:#d25b70;box-shadow:200px -70px #d25b70}[b]{bottom:0;border-radius:0 20px;box-shadow:200px -150px #f7f3da}</style>',
}
